import React from "react";
import propTypes from 'prop-types';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { Picture } from '_ui-core-js/React/components/Picture.jsx';
import { Link } from './Link'

export function NextStepCard(props) {

  const { 
    id,
    leadText, 
    heading, 
    thumbnail, 
    cta, 
    layout,
    gtmComponentGroup,
    gtmComponentName,
    gtmName,
    gtmLabel
  } = props;

  const block = 'c-next-step-card';

  return (
    <li className={block} data-layout={layout}>
      <section className={`${block}__content`}>
        <h3 className={`${block}__heading`}>
          <CssAnimation
            enter={{
              name: 'short-slide-up-fade-in',
              delay: '0.5, hidden',
              duration: 1
            }}
            triggerEnter={'in-view-init'}
          >
            <span className={`${block}__lead-text h6`}>
              {leadText}
            </span>
          </CssAnimation>

          <CssAnimation
            enter={{
              name: 'short-slide-up-fade-in',
              delay: '1, hidden',
              duration: 1
            }}
            triggerEnter={'in-view-init'}
          >
            <span className={`${block}__primary-heading h4`}>
              {heading}
            </span>
          </CssAnimation>
        </h3>
        <hr />

        <div className={`${block}__btn-container`}>
          <Link
            label={cta?.label}
            href={cta?.href}
            type='tertiary'
            cssAnimation={true}
            dataAttributes={cta?.dataAttributes}
            gtmComponentGroup={gtmComponentGroup}
            gtmComponentName={gtmComponentName}
            gtmName={gtmName}
            gtmLabel={cta?.href || id ? id : gtmLabel }
          />
        </div>
      </section>
      <div className={`${block}__thumbnail`}>
        <CssAnimation
          enter={{
            name: 'horizontal-right-left-reveal',
            target: 'psuedo-element-after',
            duration: 0.75
          }}
          triggerEnter={'in-view-init'}
        >
          <div>
            <Picture {...{
              ...thumbnail
            }} />
          </div>
        </CssAnimation>
      </div>
    </li>
  );
}

NextStepCard.propTypes = {
  leadText: propTypes.string.isRequired,
  heading: propTypes.string.isRequired,
  thumbnail: propTypes.object.isRequired,
  cta: propTypes.object.isRequired,
  gtmComponentGroup: propTypes.string,
  gtmComponentName: propTypes.string
};

NextStepCard.defaultProps = {
  layout: 'horizontal'
}
